import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const SESSION_KEY = 'lykbl_marketing_session_id';

/**
 * Records one privacy-preserving page hit per client-side route. The edge
 * function filters the owner's configured IP and bots before writing anything,
 * and never stores raw IP addresses.
 */
export default function MarketingAnalytics() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;

    const sessionId = getSessionId();
    if (!sessionId) return;

    const params = new URLSearchParams(location.search);
    void supabase.functions.invoke('marketing-analytics', {
      body: {
        path: location.pathname,
        referrer: document.referrer || null,
        session_id: sessionId,
        utm_source: cleanParam(params.get('utm_source')),
        utm_medium: cleanParam(params.get('utm_medium')),
        utm_campaign: cleanParam(params.get('utm_campaign')),
      },
    });
  }, [location.pathname, location.search]);

  return null;
}

function getSessionId(): string | null {
  try {
    const existing = window.sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const created = window.crypto.randomUUID();
    window.sessionStorage.setItem(SESSION_KEY, created);
    return created;
  } catch (_) {
    return null;
  }
}

function cleanParam(value: string | null): string | null {
  const cleaned = value?.trim();
  return cleaned ? cleaned : null;
}
